export default async function uploadFileToDrupal(file, entityType, bundle, fieldName) {
	const uploadUrl = `${process.env.CLF_BACKEND_URL}/file/upload/${entityType}/${bundle}/${fieldName}`;
	const formData = new FormData();
	formData.append("file", file);
	console.log("Uploading file to:", uploadUrl);
	console.log("File to upload:", file);
	console.log("Form data:", formData);
	console.log("Entity type:", entityType);
	console.log("Bundle:", bundle);

	try {
		const response = await fetch(uploadUrl, {
			method: "POST",
			body: formData,
		});

		if (response.ok) {
			const fileData = await response.json();
			return fileData;
		} else {
			throw new Error("File upload failed: " + response.statusText);
		}
	} catch (error) {
		return { error: error.message };
	}
}
